// Copyright (c) 2022 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const calculatePercentageValue = (state, action) => action.percentageCalc;

const resetPercentageDebit = () => getDefaultState().amountDebit;

export default (state = getDefaultState().amountDebit, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_PERCENTAGE_DEBIT]: resetPercentageDebit,
        [actions.CALCULATE_TCSM_PERCENTAGE_DEBIT_VALUE]: calculatePercentageValue
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/reducers/calculate-percentage.js